import React from 'react';
import styles from './ReportCardHeader.module.scss';
import { ReportCardHeaderActions } from './ReportCardHeaderActions/ReportCardHeaderActions';
import { SFChip, SFText } from 'sfui';

export interface ReportCardHeaderProps {
  className?: string;
  incidentNumber: string;
  caseNumber?: string | undefined;
  isReportable?: boolean;
  onViewHistory: () => void;
  onScanQrCode: () => void;
  onSeeFullReport: () => void;
}

export const ReportCardHeader = ({
  className = '',
  incidentNumber,
  caseNumber,
  isReportable,
  onViewHistory,
  onScanQrCode,
  onSeeFullReport
}: ReportCardHeaderProps): React.ReactElement<ReportCardHeaderProps> => {
  const reportableToStateChips = () => {
    return (
      <div className={styles.reportableStatusChip}>
        {isReportable && (
          <SFChip
            label="Reportable to the state"
            variant="outlined"
            size="small"
            sfColor="primary"
          />
        )}
        {!isReportable && (
          <SFChip
            label="Not reportable to the state"
            variant="outlined"
            size="small"
            sfColor="grey"
          />
        )}
      </div>
    );
  };

  return (
    <div className={`${styles.reportCardHeader} ${className}`}>
      {caseNumber && (
        <div className={styles.incidentNumber}>
          <SFText type="component-messages" sfColor="neutral">
            CAD / CASE NUMBER
          </SFText>
          <div className={styles.valueAndChips}>
            <SFText type="component-title">{caseNumber}</SFText>
            {reportableToStateChips()}
          </div>
        </div>
      )}

      {!caseNumber && (
        <div className={styles.incidentNumber}>
          <SFText type="component-messages" sfColor="neutral">
            INCIDENT NUMBER
          </SFText>
          <div className={styles.valueAndChips}>
            <SFText type="component-title">{incidentNumber}</SFText>
            {reportableToStateChips()}
          </div>
        </div>
      )}

      <ReportCardHeaderActions
        onViewHistory={onViewHistory}
        onScanQrCode={onScanQrCode}
        onSeeFullReport={onSeeFullReport}
      />
    </div>
  );
};
